<template>
  <div class="promo-banner__section">
    <div class="promo-banner__text">
      {{ promoText }}
    </div>
    <div class="promo-banner__button">
      <a
        :href="checkoutLink"
        target="_blank"
        rel="noopener nofollow"
        class="btn btn--primary promo-banner__button-cta"
      >
        {{ promoButtonLabel }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PromoBanner',
  data() {
    return {
      promoText: 'Unlock all of INE’s great content when you upgrade!',
      promoButtonLabel: 'Upgrade now!',
    }
  },
  computed: {
    checkoutLink() {
      return `//${process.env.VUE_APP_CHECKOUT_URL}`
    },
  },
}
</script>

<style lang="scss">
.promo-banner {
  &__section {
    background: var(--glass-purple);
    margin-top: 60px;

    @mixin biggerDevices {
      height: 295px;
      display: flex;
      justify-content: center;
      flex-flow: column;
      background-image: url('../../../assets/images/backgrounds/upgrade.jpg');
    }
    @include tablet {
      @include biggerDevices;
      background-position-x: center;
      background-position-y: center;
    }
    @include desktop {
      @include biggerDevices;
      background-size: cover;
    }
  }
  &__text {
    font-family: var(--font-book);
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 32px;
    text-align: center;
    color: var(--white);
    padding: 40px 25px;
  }
  &__button {
    padding-bottom: 40px;
    text-align: center;
    &-cta {
      width: 335px;
    }
  }
}
</style>
